const orderGrid = {
    orderGridGas: function (data) {
        // Define the desired order of states
        const stateOrder = [
            "United Kingdom",
            "Germany",
            "Netherlands",
            "France",
            "Italy",
            "Ireland",
            "Northern Ireland",
            "Belgium",
            "Austria",
            "Spain",
            "Czech Rep.",
            "Slovakia",
            "Hungary",
            "Nordics",
            "Switzerland",
            "Poland",
            "Romania",
            "Estonia",
            "Lithuania",
            "Luxembourg"
        ];

        // Build a map of state -> item for known states
        const stateMap = {};
        const restOfWorldMap = new Map();

        for (var i = 0; i < data.length; i++) {
            if (stateOrder.includes(data[i].state)) {
                stateMap[data[i].state] = data[i];
            } else {
                restOfWorldMap.set(data[i].priceAreaName, data[i]);
            }
        }

        // Sort rest of world alphabetically
        const restOfWorld = Array.from(restOfWorldMap.values()).sort(function (a, b) {
            let x = a.state.toLowerCase();
            let y = b.state.toLowerCase();
            if (x < y) { return -1; }
            if (x > y) { return 1; }
            return 0;
        });

        // Build ordered list from stateOrder, filtering out states not present in data
        const ordered = stateOrder
            .filter(state => stateMap[state])
            .map(state => stateMap[state]);

        return [...ordered, ...restOfWorld];
    }
}

export default orderGrid;